<template>
  <span class="button-loader" :class="[`loader-${color}`, `loader-${size}`]">
    <span class="loader-spinner"></span>
  </span>
</template>

<script>
export default {
  name: "ButtonLoader",
  props: {
    color: {
      type: String,
      default: "white", // white, primary, dark
      validator: (value) => ['white', 'primary', 'dark'].includes(value)
    },
    size: {
      type: String,
      default: "medium", // small, medium, large
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    }
  }
};
</script>

<style lang="scss" scoped>
.button-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.loader-spinner {
  display: inline-block;
  border-radius: 50%;
  border-style: solid;
  animation: buttonSpin 0.7s linear infinite;
}

// Size variants
.loader-small .loader-spinner {
  width: 14px;
  height: 14px;
  border-width: 2px;
}

.loader-medium .loader-spinner {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.loader-large .loader-spinner {
  width: 24px;
  height: 24px;
  border-width: 3px;
}

// Color variants
.loader-white .loader-spinner {
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
}

.loader-primary .loader-spinner {
  border-color: rgba(77, 132, 255, 0.2);
  border-top-color: #4D84FF;
}

.loader-dark .loader-spinner {
  border-color: rgba(15, 23, 42, 0.2);
  border-top-color: #0F172A;
}

@keyframes buttonSpin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
